// extracted by mini-css-extract-plugin
export var dividerLine = "_74-3";
export var itemImage = "_74-9";
export var lightDivider = "_74-4";
export var modalContent = "_74-5";
export var modalContentCompact = "_74-6";
export var productCard = "_74-a";
export var productImage = "_74-b";
export var productImageCompact = "_74-7";
export var productImagePlaceholder = "_74-c";
export var productImagePlaceholderCompact = "_74-8";
export var progressBarBackground = "_74-1";
export var progressBarContainer = "_74-0";
export var progressBarFill = "_74-2";